var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-domain"},[_c('add-domain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }